export const COLUMNS = [
  'table.header.name',
  'table.header.id',
  'table.header.sourceType',
  'table.header.lastUpdate',
]

export const ACTIONS = [
  {
    icon: 'play-circle',
    event: 'export',
    name: 'table.actions.export',
  },
  {
    icon: 'calendar',
    event: 'schedule',
    name: 'table.actions.schedule',
  },
]
